'use strict';

var once = require('once');

var ConcatStream = require('concat-stream');

var SendFilesStream = require('./send-files-stream');

module.exports = function (send, path) {
  var sendFilesStream = SendFilesStream(send, path);
  return function (file, options, _callback) {
    var callback = once(_callback);
    var stream = sendFilesStream(options);
    var concat = ConcatStream(function (results) {
      return callback(null, results);
    });
    stream.once('error', callback);
    stream.pipe(concat);
    stream.write(file);
    stream.end();
  };
};